import axios, { AxiosPromise } from 'axios';
import { DADATA_KEY } from 'SharedDir/constants/app/endpoints';
import { Dadata } from 'SharedDir/declarations/dadata';

/*
  ДОКУМЕНТАЦИЯ https://dadata.ru/api/suggest/address/
*/

/**
 * Адрес Дадаты
 */
const DADATA_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

/**
 * Токен дадаты
 */
// const DADATA_TOKEN: string = DADATA_KEY;

/**
 * Количество результатов (максимум — 20)
 */
const COUNT_RESULT: number = 10;

/**
 * Язык возврата результатов
 */
const LANGUAGE_RESULT: string = 'ru';

/**
 * Ограничение по родителю (Страна, регион, район)
 * Ограничение по стране
 */
const LOCATION_RESTRICT = [
  {
    country_iso_code: 'RU',
  },
];

/**
 * Приоритет города при ранжировании
 */
const LOCATION_BOOST: Array<object> = [{ kladr_id: '86' }];

/**
 * Откуда и до куда будут идти подсказки пользователю
 */
const FROM_BOUND: Dadata.TBound = {
  value: 'region',
};

const TO_BOUND: Dadata.TBound = {
  value: 'street',
};

export const BOUND_TYPES: Array<Dadata.BoundsType> = [
  'country',
  'region',
  'area',
  'city',
  'settlement',
  'street',
  'house',
  'flat',
];

export const BOUND_OPTIONS: Dadata.BoundOptions = [
  {
    value: 'country',
    label: 'Страна',
  },
  {
    value: 'region',
    label: 'Регион',
  },
  {
    value: 'area',
    label: 'Район',
  },
  {
    value: 'city',
    label: 'Город',
  },
  {
    value: 'settlement',
    label: 'Населенный пункт',
  },
  {
    value: 'street',
    label: 'Улица',
  },
  {
    value: 'house',
    label: 'Дом',
  },
  {
    value: 'flat',
    label: 'Квартира',
  },
];

const getSuggestions = ({
  query,
  token,
  url = DADATA_URL,
  count = COUNT_RESULT,
  toBound = TO_BOUND,
  fromBound = FROM_BOUND,
  language = LANGUAGE_RESULT,
  locations = LOCATION_RESTRICT,
  locationsBoost = LOCATION_BOOST,
}: Dadata.Suggestion): AxiosPromise<{ suggestions: Array<Dadata.DadataSuggestion> }> => {
  const data: Dadata.SuggestionPayload = {
    query,
    count,
    to_bound: toBound,
    from_bound: fromBound,
    language,
    locations,
    locations_boost: locationsBoost,
  };

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Token ${token}`,
  };

  const axiosInstance = axios.create({
    baseURL: '',
    timeout: 4000,
    headers,
  });

  return axiosInstance({
    url,
    method: 'POST',
    data,
  });
};

export default getSuggestions;
